import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DebugModeService } from './debug-mode.service';
import { ComponentDebugFeatureService } from './component-debug-feature.service';

@NgModule({
    imports: [CommonModule],
    providers: [DebugModeService, ComponentDebugFeatureService],
})
export class DebugModeModule {
    constructor(
        private debugModeService: DebugModeService,
        private featureService: ComponentDebugFeatureService
    ) {
        // Services are initialized when module loads
    }
}
